import i18n from '@Lang'
import { clone } from '@U/handle'
import { getLastNDay } from '@U/dateUtil'
import store from '@S'

function initTimes(v) {
  if (v.times && v.times.length) {
    return v.times
  }
  if (v.beginDate && v.endDate) {
    return [v.beginDate, v.endDate]
  }
  return [getLastNDay(6), getLastNDay(0)]
}

export function formatConditions(conditions) {
  if (!conditions || !conditions.length) {
    return []
  }
  const arr = conditions.map(item => {
    const obj = new Condition(item)
    if (obj.connector === 'range') {
      delete obj.value
    } else {
      if (String(obj.value)) {
        if (typeof obj.value === 'number') {
          obj.value = [String(obj.value)]
        } else if (typeof obj.value === 'string') {
          obj.value = [obj.value]
        }
      } else {
        obj.value = []
      }
      delete obj.start
      delete obj.end
    }
    return obj
  })
  return arr
}

class Condition {
  constructor(v) {
    v = v || {}
    this.condition = v.condition || '' // 条件key
    this.connector = v.connector || 'eq' // 条件连接符
    this.value = String(v.value) ? v.value : '' // 条件value
    this.dataType = v.dataType || '' // 数据类型
    this.start = String(v.start) ? v.start : ''
    this.end = String(v.end) ? v.end : ''
  }
}

class Overall {
  constructor(v) {
    v = v || {}
    this.appKey = v.appKey || ''
    this.chart = v.chart || 'trend'
    this.conditions = v.conditions || []
    this.frequency = v.frequency || 'day'
    this.group = v.group || ''
    this.indicators = this.chart === 'number' ? v.indicators instanceof Array && v.indicators.length ? v.indicators[0] : '' : (v.indicators || [])
    this.times = initTimes(v)
  }

  commit() {
    const data = clone(this)
    data.beginDate = data.times[0]
    data.endDate = data.times[1]
    delete data.times
    if (['total', 'number'].includes(data.chart)) {
      this.frequency = 'day'
      if (data.chart === 'number') {
        data.group = ''
      }
    }
    data.conditions = formatConditions(data.conditions)
    return data
  }
}

class Event {
  constructor(v) {
    v = v || {}
    this.projectId = store.getters.currentProjectId
    this.appKey = v.appKey || ''
    this.event = v.event || ''
    this.chart = v.chart || 'trend'
    this.conditions = v.conditions || []
    this.frequency = v.frequency || 'day'
    this.group = v.group || ''
    this.indicators = v.indicators || []
    this.times = initTimes(v)
  }

  commit() {
    const data = clone(this)
    data.beginDate = data.times[0]
    data.endDate = data.times[1]
    delete data.times
    if (['total', 'number'].includes(data.chart)) {
      this.frequency = 'day'
      if (data.chart === 'number') {
        data.group = ''
      }
    }
    if (data.event === i18n.t('analysis.eventOverview')) {
      data.event = 'eventOverview'
    }
    data.conditions = formatConditions(data.conditions)
    return data
  }
}

class Custom {
  constructor(v) {
    v = v || {}
    this.customId = v.customId || []
    this.appKey = v.appKey || ''
    this.group = v.group || ''
    this.chart = v.chart || 'trend'
    this.indicatorLeft = v.indicatorLeft || ''
    this.indicatorRight = v.indicatorRight || ''
    this.frequency = v.frequency || 'day'
    this.times = initTimes(v)
  }

  commit() {
    const data = clone(this)
    const customIds = []
    customIds.push(data.indicatorLeft)
    if (data.indicatorRight !== '') {
      customIds.push(data.indicatorRight)
    }
    data.customId = customIds

    data.beginDate = data.times[0]
    data.endDate = data.times[1]
    delete data.times
    if (['total', 'number'].includes(data.chart)) {
      this.frequency = 'day'
      if (data.chart === 'number') {
        data.group = ''
      }
    }
    return data
  }
}

export {
  Condition,
  Overall,
  Event,
  Custom
}
